export enum RoleTypes {
  GASF = 'GASF',
  GFAA = 'GFAA',
  TRTR = 'TRTR',
  SHSH = 'SHSH',
  EXEX = 'EXEX',
  EXAD = 'EXAD',
  GLAA = 'GLAA',
}
